import jwt_decode from "jwt-decode"

export const decodeToken = (token) => {
    var decoded = jwt_decode(token)

    checkTokenExpiration(decoded.exp)

    return decoded;
}

export const checkTokenExpiration = (exp) => {
    const now = Date.now().valueOf() / 1000

    if (typeof exp !== 'undefined' && exp < now)
        throw new Error("Token expired")
}